<template>
  <div class="select-part">
    <label class="name">{{filterName}}</label>
    <filter-fence :index="index" >
      <template v-for="item in letterList" v-if="type=='letter'">
        <filters-item :item="item" :name="item"  @clickItem="clickItem" />
      </template>

      <template v-for="(item,itemIndex) in childItem" v-if="type!=='letter'" >
        <filters-item :item="item" :name="item.name"  @clickItem="clickItem" />
      </template>
    </filter-fence>
  </div>
</template>

<script>
import filterFence from './filterFence.vue';
import FiltersItem from './filtersItem.vue';
export default {
  components: { filterFence, FiltersItem },
  name: 'filterGrid',
  props: {
    filterName:String,
    type: String,
    childItem:Array,
    index:Number,
    curFilter:[Array,Object] ,//当前选中项
  },
  data(){
    return{
      letterList:["a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z",'#'],
      curItem:'',
    }
  },
  computed:{
    
  },
  watch:{
    childItem:{
      handler(news,olds){
        // console.log("chidl",news)
      },
      immediate: true
    },
    curFilter:{
      handler(newval,oldval) {
        if(!newval){
          this.curItem='';
          return;
        }
        this.curItem = newval.childItem;
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true
    },
     
  },
  mounted() {
   
  },
  methods:{
    clickItem(info){
      
      let curFilter = this.curFilter;
      let funcName ="chooseItem";
      if(curFilter &&  curFilter.items ){
        curFilter.items.forEach(subitem=>{
          if(info.name == subitem.name ||　info == subitem.name){
            funcName = "deleteItem"
          }
        });
      }
      let item = {
        name:info.name|| info,
        id:info.id || ''
      }
      let items=[];
      items.push(item)
      this.$emit(funcName,{
        "index":this.index,
        "filterName":this.filterName,
        "type":this.type,
        "items":items
      })
    }
  }
}
</script>
<style scoped >


</style>